module.exports = __webpack_public_path__ + "media/era_sweepstakes/twitter-x-76afdd8f.svg";